// extracted by mini-css-extract-plugin
export default {"supportButton":"SupportButton_supportButton__4gxHs","headsetIcon":"SupportButton_headsetIcon__+wTGP"};